(function () {
  'use strict';

  function buildLinkUrl(baseUrl) {
    if (!baseUrl) return 'https://carterhouck.com';
    try {
      const url = new URL(baseUrl, window.location.origin);
      if (!url.searchParams.has('utm_source')) {
        url.searchParams.set('utm_source', 'nothingradio');
      }
      if (!url.searchParams.has('utm_medium')) {
        url.searchParams.set('utm_medium', 'footer');
      }
      return url.toString();
    } catch (e) {
      return baseUrl;
    }
  }

  function initCreditAnimation() {
    const credit = document.querySelector('.nr-footer-bar__credit');
    if (!credit) return;

    const defaultText = credit.getAttribute('data-default') || '';
    const hoverText = credit.getAttribute('data-hover') || '';
    const linkText = credit.getAttribute('data-hover-link-text') || '';
    const linkUrl = buildLinkUrl(credit.getAttribute('data-hover-link-url') || '');
    let isAnimating = false;
    let isHoverState = false;
    let currentPlainText = defaultText;

    function setPlainText(text) {
      credit.textContent = text;
      currentPlainText = text;
    }

    function injectLink() {
      if (!linkText || !hoverText.includes(linkText)) {
        setPlainText(hoverText);
        return;
      }

      const prefix = hoverText.slice(0, hoverText.indexOf(linkText));
      const anchor = document.createElement('a');
      anchor.href = linkUrl;
      anchor.className = 'nr-footer-bar__credit-link';
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      anchor.setAttribute('data-from', 'nothingradio');
      anchor.textContent = linkText;

      credit.textContent = '';
      credit.appendChild(document.createTextNode(prefix));
      credit.appendChild(anchor);
      currentPlainText = hoverText;
    }

    function animateText(fromText, targetText, onComplete) {
      if (isAnimating || !targetText) return;
      isAnimating = true;

      const maxLength = Math.max(fromText.length, targetText.length);
      let currentIndex = 0;

      const interval = setInterval(function () {
        if (currentIndex <= maxLength) {
          let newText = '';
          for (let i = 0; i < maxLength; i++) {
            if (i < currentIndex) {
              newText += targetText[i] || '';
            } else {
              newText += fromText[i] || '';
            }
          }
          credit.textContent = newText.trim();
          currentIndex++;
        } else {
          clearInterval(interval);
          currentPlainText = targetText;
          isAnimating = false;
          if (onComplete) {
            onComplete();
          } else {
            credit.textContent = targetText;
          }
        }
      }, 30);
    }

    setPlainText(defaultText);

    function showHover() {
      if (isHoverState || isAnimating) return;
      isHoverState = true;
      animateText(currentPlainText, hoverText, injectLink);
    }

    function showDefault() {
      if (!isHoverState || isAnimating) return;
      isHoverState = false;
      const fromText = currentPlainText;
      setPlainText(fromText);
      animateText(fromText, defaultText);
    }

    credit.addEventListener('mouseenter', showHover);
    credit.addEventListener('mouseleave', showDefault);
    credit.addEventListener('focus', showHover);
    credit.addEventListener('blur', function (event) {
      if (credit.contains(event.relatedTarget)) return;
      showDefault();
    });

    credit.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (isHoverState) {
          showDefault();
        } else {
          showHover();
        }
      }
      if (event.key === 'Escape' && isHoverState) {
        showDefault();
        credit.blur();
      }
    });
  }

  function initSupabaseHeartbeat() {
    var hook = document.querySelector('[data-nr-supabase-heartbeat]');
    if (!hook) return;

    var endpoint = (hook.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
    var eventId = hook.getAttribute('data-event-id') || '';
    if (!endpoint || !eventId) return;

    var today = new Date().toISOString().slice(0, 10);
    var storageKey = 'nr-supabase-hb-' + today;

    try {
      if (sessionStorage.getItem(storageKey)) return;
      sessionStorage.setItem(storageKey, '1');
    } catch (e) {
      /* sessionStorage unavailable — still attempt the ping */
    }

    fetch(endpoint + '/api/events/' + encodeURIComponent(eventId)).catch(function () {});
  }

  function init() {
    initCreditAnimation();
    initSupabaseHeartbeat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
